angular.module("registrace")

.controller('RegistraceOkCtrl', ["$scope", "$location", "$http", "api", "Container", "$window", "Registrace", function($scope, $location, $http, api, Container, $window, Registrace) {

	$scope.step2response = {};
	$scope.container = {};
	$scope.loading = false;

	$scope.data = {
		customized: false
	};

    $scope.deaktivateApp = deaktivateApp;

    if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
        api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
        return;
    }

	$scope.init = function() {
		api.logAnonymousAppAction('REGISTRACE', 'VIEW', 'STEP', 'Dokončení');
		$scope.data.customized = Container.getCustomized();
	};

	$scope.init();

	$scope.login = function() {
		api.logAnonymousAppAction('REGISTRACE', 'LOGIN', 'QUICK', '');
		$scope.loading = true;

		$scope.loginData = {
			url: "/irj/portal/prehled-uctu",
			j_user: Container.getFormDataContainer().step1.loginName,
			j_password: Container.getFormDataContainer().step2.heslo
		};

		$("#okForm").submit();
/*
		PREDELANO NA SKRYTY FORM KULI PRESMEROVANI NA HTTP A ZPET NA F5

		var _url = "/irj/portal/prehled-uctu";
		// var _url = $location.protocol() + "://" + $location.host() + ":" + $location.port() + "/irj/portal/prehled-uctu";
		var loginData = {
			login_submit: 'on',
			login_do_redirect: '1',
			no_cert_storing: 'on',
			j_authscheme: 'default',

			j_user: Container.getFormDataContainer().step1.loginName,
			j_password: Container.getFormDataContainer().step2.heslo
		};

		if ($scope.data.customized) {
			loginData.zpnd = true;
		}

		$http({
			method: 'POST',
			url: _url,
			data: $.param(loginData),
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).success(function(response) {
			$scope.loading = false;
			//				$('html').html(response);
			if ($scope.data.customized) {
				if (location.search.match('cezonlinet.cez.cz') || location.search.match('/petci.cezdata.corp')) {
					$window.location.href = "https://pndt.cez.cz/cezpnd/external/corporate/dashboard";
				} else {

					$window.location.href = "https://pnd.cez.cz";
				}
			} else {
				$window.location.href = _url;
			}
		});
*/
	};
}]);